import { render, staticRenderFns } from "./tournamentStatisticsTab.vue?vue&type=template&id=0b0e314f&"
import script from "./tournamentStatisticsTab.vue?vue&type=script&lang=js&"
export * from "./tournamentStatisticsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports